module.exports = __webpack_public_path__ + "img/manageVersion.2008dc8f.svg";